/** Dependencies */
import BaseService from './BaseService';
import appConfig from '../appConfig';

class LoyaltyService {
  constructor() {
    this.baseService = new BaseService(appConfig.loyaltyServiceUrl);
  }

  getOrderPremiumText(params) {
    return this.baseService.get('/order-premium-text', { params });
  }

  getCustomerInfo(params) {
    return this.baseService.get('/subscription-domain-info', params);
  }

  getFulfillmentAvailability() {
    return this.baseService.get('/one-click-fulfillment-availability');
  }

  useCouponCode(data) {
    return this.baseService.put('/coupon-campaign/code/check', data);
  }

  assignCode(data) {
    return this.baseService.put('/coupon-campaign/code/assign', data);
  }

  openPremiumCheckout(utmSourceParamSearch, data) {
    return this.baseService.put(`/pre-checkout${utmSourceParamSearch}`, data);
  }

  getHistory(data) {
    return this.baseService.get('/subscription-and-history/customer', {
      headers: {
        'customer-id': data,
        'user-id': data
      }
    });
  }

  calculateAdvantagesByProduct(params) {
    return this.baseService.post('/calculate-for-selected-item', params, {
      headers: {
        'user-id': params.customerId
      }
    });
  }

  getAccountMenuLoyaltyHeaderData(params) {
    return this.baseService.get('/v1/mobile-account-menu-header', params);
  }

  getEarnings = () => {
    return this.baseService.get('/current-earnings', { params: { periodId: -1 } });
  };

  getSubscriptionDateInfo = () => {
    return this.baseService.get('/subscription-date-info');
  };

  revertCancelRequest = () => {
    return this.baseService.put('/revert-cancel-demand', {});
  };

  getUserSummaryData = params => {
    return this.baseService.get('/one-click-fulfillment-info', { params });
  };

  getOrderTouchPointData = () => {
    return this.baseService.get('/v1/my-orders');
  };

  getOrderSuccessTouchPointData = () => {
    return this.baseService.get('/v1/order-pay-completed');
  };

  getAccountSideBarData = () => {
    return this.baseService.get('/v1/account-sidebar');
  };

  getOrderDetailData = shippingPrice => {
    return this.baseService.get(`/v1/order-detail?shippingCompensationAmount=${shippingPrice}`);
  };

  getSolutionCenterTouchPointData = () => {
    return this.baseService.get('/v1/customer-success');
  };

  getCancelReasons = () => {
    return this.baseService.get('/loyalty-cancellation-reasons');
  };

  getConvincingText = cancelReasonId => {
    return this.baseService.get(`/loyalty-convince-message/${cancelReasonId}`);
  };

  getHomepageTouchPointCampaigns = () => {
    return this.baseService.get('/v1/dynamic-bottomsheets/homepage/details');
  };

  getCancellationBenefit = period => {
    return this.baseService.get('/cancel-request-info', { params: period });
  };

  getPaymentInfo = subsId => {
    return this.baseService.get(`/subscription/status/expired/payment-info/${subsId}`);
  };

  retryPayment = data => {
    return this.baseService.put('/renew-subscription-bycustomer', data);
  };

  getEarningsInfo = () => {
    return this.baseService.get('/earnings-show-info/overall');
  };

  getLoyaltyDetailTouchPointData = source => {
    return this.baseService.get(`/v1/dynamic-bottomsheets/${source}/details`);
  };
}

export default new LoyaltyService();
